import { useBrandUrl } from "@/hooks";
import { CLASSIFIED_ANALYTICS_PATH } from "@/constants";
import { useClassifiedId } from "@/contexts/classified";
import { sendClassifiedAnalytics } from "@/api/sendClassifiedAnalytics";
import { useCallback } from "react";
import { useConfig } from "@/contexts/cdpConfig";
export const useClassifiedAnalytics = () => {
    const analyticsUrl = useBrandUrl({ endpoint: CLASSIFIED_ANALYTICS_PATH });
    const classifiedId = useClassifiedId();
    const isPreviewMode = useConfig().previewMode;
    const sendClassifiedAnalyticsEvent = useCallback((eventType) => {
        if (!isPreviewMode) {
            const eventData = {
                type: eventType,
                data: {
                    classifiedId,
                },
            };
            sendClassifiedAnalytics(analyticsUrl, eventData);
        }
    }, [isPreviewMode, classifiedId, analyticsUrl]);
    return { sendClassifiedAnalyticsEvent };
};
